import styled from "styled-components";
import React from "react";
import { UserWallet } from "../../assets/User/UserWallet";
import { gql, useQuery } from "@apollo/client";
import { Loading } from "../../components/Loading";
import { formatPrice } from "../../components/helper/Price";

const StyleCss = styled.div`
  .content {
    .walletdata {
      margin: 7.5px 7.5px 15px;
      border-bottom: 1px solid var(--n-grey-3);
      display: flex;
      flex-wrap: wrap;
      .row {
          width: calc(calc(100% / 3) - 30px);
          padding: 0 15px;
          .title {
              margin: 0.5rem 0 0.3rem;
              font-weight: 500;
          }
          .data {
              margin: 0 0 0.5rem;
          }
      }
    }
    .trans {
      margin: 7.5px;
      padding: 5px 10px;
      border: 1px solid var(--n-grey-3);
      background-color: var(--n-grey-1);
      border-radius: 8px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      &.header {
        border: none;
        background-color: transparent;
        margin: 7.5px 7.5px 0;
        font-weight: 500;
        .column {
          padding: 0.5rem 0.5rem 0;

        }
      }
      .column {
        padding: 0.5rem;
      }
    }
  }
`;

export const UserWalletTrans_query = gql`
  query UserWallet {
      getUserTransactions{
        _id
        type
        name
        link
        amountIn
        amountOut
        state
      }
      getUserWallet{
        active
        balance
        Information {
          NationalCode
          AcountMobile
          IRSH
          NameOfAcount
          BankName
        }
      }
    }
`;



function TransactionsData(props) {
  const trans = useQuery(UserWalletTrans_query, {
    fetchPolicy: "network-only"
  })
  if(trans.loading){
    return (
      <StyleCss className="main-box">
        <div className="title-bar">
            <div className="title">
              <div className="icon"><UserWallet/></div>
              <div className="text">کیف پول</div>
            </div>
        </div>
        <div className="content">
          <Loading/>
        </div>
      </StyleCss>
    )
  }
  const stateFunc = (state) => {
    switch(state) {
      case 0:
        return 'کنسل شده';
      case 1:
        return 'معلق';
      case 2:
        return 'تایید شده';
      default:
        return;
    }
  }
  const dataTitle = (title, data) => {
    return (
        <div className='row'>
            <div className='title'>
                {title}
            </div>
            <div className='data'>
                {data}
            </div>
        </div>
    )
  }
  // default form
  let data = trans.data.getUserTransactions.map((value,index) => {
    return (
      <div className="trans" key={index}>
        
        <div className="column">
          {value.type}
        </div>
        <div className="column">
          {formatPrice(value.amountIn)}
        </div>
        <div className="column">
          {formatPrice(value.amountOut)}
        </div>
        <div className="column">
          {stateFunc(value.state)}
        </div>
      </div>
    )
  });

  let wallet = trans.data.getUserWallet
  let walletinf = trans.data.getUserWallet.Information

  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><UserWallet/></div>
            <div className="text">کیف پول</div>
          </div>
      </div>
      <div className="content">
        <div className="walletdata">
          {dataTitle('وضعیت:', (wallet.active) ? 'فعال' : 'غیر فعال')}
          {dataTitle('موجودی:', wallet.balance)}
          {dataTitle('کد ملی:', walletinf.NationalCode)}
          {dataTitle('موبایل حساب:', walletinf.AcountMobile)}
          {dataTitle('نام دارنده حساب:', walletinf.NameOfAcount)}
          {dataTitle('نام بانک:', walletinf.BankName)}
          {dataTitle('شماره حساب:', walletinf.IRSH)}
        </div>
        <div className="trans header">
          <div className="column">
            نوع
          </div>
          <div className="column">
            ورود به کیف {'(ریال)'}
          </div>
          <div className="column">
            خروج از کیف {'(ریال)'}
          </div>
          <div className="column">
            وضعیت
          </div>
        </div>
        {data}
      </div>
    </StyleCss>
);
}
export default TransactionsData;